import { render, staticRenderFns } from "./DialogConfirmation.vue?vue&type=template&id=dff8de54&scoped=true&"
import script from "./DialogConfirmation.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmation.vue?vue&type=style&index=0&id=dff8de54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8de54",
  null
  
)

export default component.exports